import React from 'react';

// Components
import SurfaceItemAvatar from '../SurfaceItemAvatar';
import WpBadge from 'Wpds/components/badge/WpBadge';

// Utils
import { getTimeAgoLabel } from 'Shared/utils/DateTime.utils';

// Styles
import '../SurfaceItemDetails.scss';

type Props = {
  surfaceItem;
};

const AsanaItemDetails = ({ surfaceItem }: Props) => {
  const createdByUserId = surfaceItem.details_panel.created_id;
  const createdByUserName = surfaceItem.details_panel.created_name;
  const assigneeUserId = surfaceItem.details_panel.assignee_id;
  const assigneeUserName = surfaceItem.details_panel.assignee_name;
  const getBadgeColor = () => {
    const { status } = surfaceItem;
    return status === 'Complete' ? 'green' : 'gray';
  };
  const badgeColor = getBadgeColor();
  const lastUpdatedTime = null;
  const lastUpdatedDisplay = lastUpdatedTime ? getTimeAgoLabel(new Date(lastUpdatedTime * 1000)) : null;
  const baseClassName = 'SurfaceItemDetails__content';
  return (
    <div className={`${baseClassName}`}>
      {(createdByUserId || createdByUserName) && (
        <div className={`${baseClassName}__row`}>
          <div className={`${baseClassName}__row__label`}>Creator:</div>
          <div className={`${baseClassName}__row__value`}>
            <SurfaceItemAvatar userId={createdByUserId} displayName={createdByUserName} />
          </div>
        </div>
      )}
      {(assigneeUserId || assigneeUserName) && (
        <div className={`${baseClassName}__row`}>
          <div className={`${baseClassName}__row__label`}>Assignee:</div>
          <div className={`${baseClassName}__row__value`}>
            <SurfaceItemAvatar userId={assigneeUserId} displayName={assigneeUserName} />
          </div>
        </div>
      )}
      {surfaceItem.status && (
        <div className={`${baseClassName}__row`}>
          <div className={`${baseClassName}__row__label`}>Status:</div>
          <div className={`${baseClassName}__row__value`}>
            <div className={`${baseClassName}__row__value__text`}>
              {' '}
              <WpBadge color={badgeColor} size="md">
                {surfaceItem.status}
              </WpBadge>
            </div>
          </div>
        </div>
      )}
      {lastUpdatedDisplay && (
        <div className={`${baseClassName}__row`}>
          <div className={`${baseClassName}__row__label`}>Last updated:</div>
          <div className={`${baseClassName}__row__value`}>
            <div className={`${baseClassName}__row__value__text`}> {lastUpdatedDisplay}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AsanaItemDetails;
